var _defs, _path, _path2, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwUpgradeFailedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 373,
    viewBox: "0 0 413.435 365.722",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient5217",
    cx: 173.78099,
    cy: 150.8327,
    r: 206.90388,
    gradientTransform: "matrix(-.6101056 .6619819 -.6829184 -.6294014 402.98608 80.149634)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.62886596,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m222.26365 25.584927s-5.08917-11.009168-15.54612-11.008183c-10.45694 0-15.55891 11.007199-15.55891 11.007199l-173.398344 300.352227s-6.988026 9.9116-1.76005 18.96877c5.228962 9.05618 17.313059 7.96944 17.313059 7.96944l346.812425 0.0108s12.07819 1.09659 17.30617-7.95958c5.22896-9.05521-1.75316-18.97665-1.75316-18.97665z",
    fill: "#ff0",
    stroke: "#df1800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21.6560879
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m242.83732 138.13685c-1.03034 4.04893-19.71542 77.84991-22.03608 86.52577-2.31969 8.67678-4.5118 16.8988-6.57922 24.66516 0 0-1.07382 4.89998-6.69134 4.89998h-1.69337c-5.61751 0-6.69134-4.89998-6.69134-4.89998-2.06742-7.76636-4.25855-15.98838-6.57921-24.66516-2.31969-8.67586-21.00188-82.47684-22.03511-86.52577-13.23865-51.86614 85.91354-53.300703 72.30567 0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206.7175,
    cy: 301.47748,
    r: 25.593596
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.70632766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m207.42187 3.7486992c-16.63266 0-23.8644 14.1152908-24.94757 16.4266348l-173.402518 300.355186h0.030761c-1.4836084 2.12838-10.0855663 15.39543-1.7841664 29.77712 8.3221269 14.41332 24.1723809 13.59831 26.7009729 13.38125 0.0415-4e-3 0.150685 3e-3 0.184569 0l346.620471 0.0308v-0.0308c2.57607 0.22046 18.3955 1.03671 26.70097-13.35049 8.33158-14.42812-0.34665-27.75027-1.78416-29.80788h0.0308l-173.31027-300.139855-0.12305-0.215331c-1.09705-2.341335-8.30365-16.4281987-24.91681-16.4266348z",
    fill: "url(#radialGradient5217)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwUpgradeFailedIcon);
export default __webpack_public_path__ + "static/media/SWUpgradeFailedIcon.c96b779c126721816935354d41738eff.svg";
export { ForwardRef as ReactComponent };